import React from 'react'
import { Row, Container, ListGroup } from 'react-bootstrap'
import { Helmet } from 'react-helmet'

const Terms = () => {
  return (
    <>
      <Helmet>
        <title>使用條款 | KOLSTAR</title>
      </Helmet>
      <main className="terms m-4">
        <Container>
          <Row>
            <h2 className="fw-bold">服務條款</h2>
            <span>
              感謝您使用典通股份有限公司（以下簡稱「本公司」）所營運之 KOLSTAR
              平台（以下簡稱為「本平台」）所提供的服務，服務內容詳述如下
              。開始使用本平台服務前，請詳細閱讀本使用條款（以下簡稱「本條款」）。當您同意授權使用本平台時，即視為您已閱讀並同意接受本條款，所有內容將成為您與本公司所訂協議的一部分。若您不同意本條款，請勿繼續使用。
            </span>
            <ListGroup variant="flush" className="my-3">
              <ListGroup.Item action>
                <h5 className="fw-bold">服務說明</h5>
                <ol>
                  <li>
                    KOLSTAR 為專門為行銷人員打造之社群平台專頁 AI
                    分析管理工具（以下簡稱「分析管理工具」），為使用者提供社群平台包括但不限於臉書粉絲專頁粉絲互動數據分析相關服務，以及
                    AI
                    網路資訊檢索服務，任何更新、加強程式、新功能及任何新增的編輯功能均受本使用條款所拘束。
                  </li>
                  <li>
                    KOLSTAR 透過 AI
                    運算系統將臉書粉絲專頁之粉絲依據互動狀況分群，協助使用者透過顧客分群之資料進行成效分析，同時提供使用者檢索去識別化的聚合型網路資訊，協助精準行銷及推廣。
                  </li>
                  <li>
                    分析管理工具須與使用者管理之臉書粉絲專頁綁定後方可取得該專頁之粉絲互動相關數據。
                  </li>
                  <li>
                    使用者利用 KOLSTAR
                    分析管理工具為其經營社群平台專頁建立儀表板，即為其儀表版資訊之擁有者，使用者在標明資料來源為「KOLSTAR」的情況下，可引用本平台提供服務的各項數據資料。
                  </li>
                  <li>
                    使用者應於其所經營之社群平台專頁，以適當方式告知粉絲(包括但不限追蹤者、訂閱者、顧客等)，其專頁載有分析管理工具，將蒐集粉絲與專頁互動之所有訊息，包括但不限於按讚、留言、私訊、點擊連結等資訊，如不同意，請勿繼續使用或瀏覽本專頁。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">使用者帳號保管義務</h5>
                <ol>
                  <li>
                    使用者帳號僅限本人使用，並僅得依本條款使用本平台。本平台只允許使用者以登入之方式使用各項服務，若以其他任何方式進入本網站系統，本網站將追究該人員相關之法律責任。
                  </li>
                  <li>
                    使用者有義務妥善保管使用者帳號、密碼及其他相關資訊，並為此使用者帳號登入系統後所進行之一切活動、行為負責，包括但不限於衍生之相關費用。
                  </li>
                  <li>
                    若使用者發現帳號內個人資料遭他人非法使用或有任何遭異常使用之情形，應立即通知本公司，並請使用者循適當法律途徑保護個人或公司權益；必要時，本公司會請使用者提供相關個人或公司資料，並有權管理該爭議帳戶之使用權限。
                  </li>
                  <li>
                    如因使用者的保管疏忽或同意由第三人使用使用者帳號，致該帳號、密碼遭他人非法使用，致本公司或其他第三人權益受損時，使用者應自行負擔相關法律及／或損害賠償責任。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">遵守法律及相關政府規範</h5>
                <ol>
                  <li>
                    傳送或發布侵害他人商標權、著作權、專利權等智慧財產權或其他權利之內容或任何形式之檔案。
                  </li>
                  <li>
                    傳送或發布對第三人之人身攻擊、鼓吹暴力、仇恨或歧視特定及不特定族群之攻擊性內容、騷擾、霸凌、散播色情或具裸露之內容、違反法律、公序良俗或其他經本公司判斷之不當內容。
                  </li>
                  <li>
                    販售依法不得於網路販售之產品，包括但不限於對身體產生生理傷害和依賴性之菸草製品、酒類產品、槍枝、管制藥品及其用具等。
                  </li>
                  <li>
                    傳送或發布非法資訊連結，包括但不限於盜版軟體、非法檔案下載、詐欺訊息、賭博、引人犯罪或其他違禁資訊，惡作劇內容、電腦病毒或侵犯隱私程式等。
                  </li>
                  <li>
                    未經粉絲同意，蒐集、處理、利用其個人資料（包括但不限於其真實姓名、聯繫方式等），或前述蒐集、處理、利用粉絲之個人資料超出其同意的特定目的範圍。
                  </li>
                  <li>引導訂閱廣告郵件、垃圾郵件。</li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">遵守法律及相關政府規範</h5>
                <span>
                  您同意對於所有上傳及發布至平台的內容及後續的通訊內容負責，前述內容包括但不限於文字、圖片及影音檔案等。
                  當您使用本平台時，應遵守網路禮儀及相關法令之規範，並同意不會進行以下行為：
                </span>
                <ol>
                  <li>
                    傳送或發布侵害他人商標權、著作權、專利權等智慧財產權或其他權利之內容或任何形式之檔案。
                  </li>
                  <li>
                    傳送或發布對第三人之人身攻擊、鼓吹暴力、仇恨或歧視特定及不特定族群之攻擊性內容、騷擾、霸凌、散播色情或具裸露之內容、違反法律、公序良俗或其他經本公司判斷之不當內容。
                  </li>
                  <li>
                    販售依法不得於網路販售之產品，包括但不限於對身體產生生理傷害和依賴性之菸草製品、酒類產品、槍枝、管制藥品及其用具等。
                  </li>
                  <li>
                    傳送或發布非法資訊連結，包括但不限於盜版軟體、非法檔案下載、詐欺訊息、賭博、引人犯罪或其他違禁資訊，惡作劇內容、電腦病毒或侵犯隱私程式等。
                  </li>
                  <li>
                    未經粉絲同意，蒐集、處理、利用其個人資料（包括但不限於其真實姓名、聯繫方式等），或前述蒐集、處理、利用粉絲之個人資料超出其同意的特定目的範圍。
                  </li>
                  <li>引導訂閱廣告郵件、垃圾郵件。</li>
                </ol>
                <span>
                  本公司不會預先審查或監控使用者上傳及發布之內容，但有權立即移除違反本條款之內容並暫停或終止相關帳號，並由使用者負一切法律責任，必要時本公司將配合有權機構進行調查。
                </span>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">提交內容的授權</h5>
                <ol>
                  <li>
                    基於本平台提供建置及管理本質，使用者同意授予本公司及本平台完整全球性的授權，本公司可以使用、修改、重製、公開傳輸、改作、散布使用者所上傳及發布於本平台的內容，永久有效。
                  </li>
                  <li>
                    為使本平台能夠提供更有效率之回應，進而使得系統更穩定、功能更加完整，使用者同意授權本公司得蒐集所有使用者於本平台之操作行為（包括但不限於使用功能之頻率、點擊行為、使用狀況等）予本公司用於優化平台。
                  </li>
                  <li>
                    若使用者不同意上述授權，請勿將提交內容以任何方式上傳、儲存至本平台。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">智慧財產權</h5>
                <ol>
                  <li>
                    本平台之軟體、程式及所有內容，包括但不限於
                    LOGO、商標、文字、圖片、影片、服務架構、網站畫面之安排、網頁設計等，均由本公司依法擁有其智慧財產權，未經授權，使用者不得使用、修改、重製、公開傳輸、改作、散布、發行、公開發表，且不得對於任何功能、軟體、程式進行還原工程
                    （reverse engineering）、解編 (de-compile) 或反向組譯
                    (disassemble)
                    。若使用者欲引用或轉載前述本平台內容，應依法取得本公司之事前書面同意。如有違反，使用者應依法對本公司負損害賠償責任（包括但不限訴訟費用及律師費等）。
                  </li>
                  <li>
                    若使用者涉及任何前述侵權之情事，本公司有權立即暫停全部或部份
                    KOLSTAR 服務，並暫停或永久終止相關帳號。
                  </li>
                  <li>
                    若使用者發現您的智慧財產權於本平台遭侵害，請將遭侵害之詳細情形及聯絡方式，並附具您為該智慧財產權人之聲明，寄至下列信箱與我們聯絡：
                    <a href="mailto:po@dsigroup.com.tw">po@dsigroup.com.tw</a>
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">本平台服務之停止、中斷</h5>
                <span>
                  本平台將依一般合理之技術及方式，維持正常運作。但於以下各項情況時，本平台有權停止、中斷提供本平台之服務：
                </span>
                <ol>
                  <li>本平台網站之網路通訊設備進行必要之保養及施工時。</li>
                  <li>發生突發性之網路通訊設備故障時。</li>
                  <li>本平台網站使用之網路通訊服務停止或無法提供服務時。</li>
                  <li>
                    因天災等不可抗力之因素或其他不可歸責於本平台之因素
                    （包括但不限於恐怖份子活動、暴動、政府行為、使用者網站與本平台通訊問題等）
                    ，致本平台網站無法提供服務。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">免責聲明</h5>
                <ol>
                  <li>
                    本公司僅依串接訊息之社群平台帳號所開放之功能及所公告之相關規範，提供
                    KOLSTAR
                    服務，對於本服務提供之品質、準確性及完整性將盡商業上合理之努力盡可能提供您最完整之體驗，但內容如有錯誤或遺漏，本公司及其管理人員、董事、員工和代理人不會承擔任何賠償責任。
                  </li>
                  <li>
                    本平台所傳播或刊載之廣告，關於其內容所展現的文字、圖片、動畫、聲音、影像或以其他方式對商品或服務之說明，使用者應該自行判斷該廣告的正確性、有效性及可信度。
                  </li>
                  <li>本平台網站使用之網路通訊服務停止或無法提供服務時。</li>
                  <li>
                    在法律允許的最大限度內，本公司茲聲明免予承擔所有有關本服務或與其連結的網站內容的準確性或完整性的保證、條件、條款和陳述，並且不承擔下列責任：
                    <ol className="type">
                      <li>本服務中出現之錯誤或內容失實。</li>
                      <li>
                        您訪問或使用本服務引起任何性質的人身傷害或財產損害。
                      </li>
                      <li>
                        未經授權訪問或使用有安全措施的伺服器和/或儲存在伺服器上的任何個人資訊和/或財務資訊。
                      </li>
                      <li>我們服務的中斷或停止傳輸。</li>
                      <li>
                        第三方可能通過我們的服務傳輸的任何軟體錯誤、病毒、木馬或類似性質的程式。
                      </li>
                      <li>
                        任何內容中的錯誤或疏忽，或由於使用發佈、郵件傳送、傳輸或通過服務的其他方式獲得的內容，導致的任何形式的損失或損害。
                        KOLSTAR
                        不保證、擔保或承擔由任何第三方通過服務或任何超連結服務或橫幅功能或其他廣告發佈或提供的產品或服務的責任，以及您與第三方提供商就商品或服務的交易。於前述情況下，您應當盡到自己最佳的判斷和合理的謹慎。
                      </li>
                    </ol>
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">終止服務</h5>
                <ol>
                  <li>
                    使用者可以隨時解除KOLSTAR個人設定中社群平台帳號之綁定。使用者亦可隨時於本平台上，主動解除授權的社群平台粉絲專頁連結與社群平台授權帳號，一旦使用者解除帳號授權，社群平台之儀表版資訊與社群平台帳號之綁定亦一併解除。若使用者需要刪除其帳號及該帳號所有儲存於本平台的資料，請與我們聯絡：
                    <a href="mailto:po@dsigroup.com.tw">po@dsigroup.com.tw</a>
                  </li>
                  <li>
                    當使用者欲停止使用 KOLSTAR
                    服務時，使用者需自行清除其管理之社群平台帳號提供給本平台的相關授權。
                  </li>
                  <li>
                    本公司為維護平台正常營運及使用者權益，於下列情況得不經事先告知使用者，永久終止該使用者帳號，移除該使用者上傳及發布於本平台之內容，且該使用者須就本公司、本平台因此所生之所有損害負賠償責任：
                    <ul className="square">
                      <li>該使用者違反本條款關於之約定。</li>
                      <li>使用者有其他足致影響本平台正常營運之行為。</li>
                    </ul>
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">
                  如何終止蒐集、處理或利用及刪除我的個人資訊
                </h5>
                <span>
                  您有權終止 KOLSTAR
                  對您進行任何的個人資料蒐集、處理及利用，並得以要求 KOLSTAR
                  刪除相關個人資料；對於您的個人資料管理，您具有以下權利：
                </span>
                <ol>
                  <li>
                    刪除權：您有權要求我們刪除您或經您導入之任何個人資料。
                  </li>
                  <li>
                    限制處理權：您有權要求我們永久停止處理所有或部分個人資料。
                  </li>
                  <li>
                    拒絕權：若您同意我們使用您的資料，您有權隨時基於您或經您導入個人資料之第三方特殊情況反對我們處理您/第三方個人資料；若您欲行使拒絕權，您可以透過系統設定的方式進行調整，或是透過{' '}
                    <a href="mailto:po@dsigroup.com.tw">po@dsigroup.com.tw</a>{' '}
                    此電郵地址與我們聯繫。
                  </li>
                  <li>
                    資料可攜權：您有權要求取得電子格式的個人資料副本，以及有權要求傳輸個人資料供另一方服務使用，惟您可能需要因此項要求負擔我們協助處理之成本及行政費用。
                  </li>
                  <li>其他依中華民國個人資料保護法第 3 條所賦與您之權利。</li>
                </ol>
                <span>
                  惟當您行使以上權利管理您的個人資料時，本服務提供的完整服務將會受到相對限制，甚至是無法繼續提供您服務。
                </span>
                <br />
                <span>
                  依據個人資料保護政策及保護會員權益的立場，如要終止 KOLSTAR
                  服務或刪除個人資料，可透過電子郵件：
                  <a href="mailto:po@dsigroup.com.tw">po@dsigroup.com.tw</a>
                  ，或撥打公司電話 (02)2331-5133(分機703)
                  進行申請。申請過程中，可能會需要您提供身分證件或其他證明文件予本公司客服單位，作身份比對及驗證之用。
                </span>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">本條款修訂及生效</h5>
                <ol>
                  <li>
                    本公司保留隨時修改本條款的權利。條款修改後經公布平台網站後即生效力，本公司將不另外個別通知使用者。我們建議使用者可以隨時點擊
                    KOLSTAR
                    平台上的「使用條款」連結，檢視最新版之使用條款，以確認本條款是否有修改。
                    本公司保留修改本協議而不需通知會員的權利。本公司對於本協議之修正，不需對會員或第三方負責。
                  </li>
                  <li>
                    若使用者在本公司修改服務條款後仍繼續使用平台之軟體與服務，即代表使用者已接受此修改條款之規範。
                  </li>
                  <li>
                    若對我們的使用條款有任何的疑問，請與我們聯絡：
                    <a href="mailto:po@dsigroup.com.tw">po@dsigroup.com.tw</a>
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item action>
                <h5 className="fw-bold">其他</h5>
                <ol>
                  <li>
                    本協議使用或說明各條標題，僅為查閱而設，不影響有關條款之解釋、說明及瞭解。
                  </li>
                  <li>
                    本協議所定之一部份條款被司法機關確認為無效時，並不影響其他條款之效力，於本公司修改該無效之條款前，應依中華民國相關法律規定處理。
                  </li>
                  <li>
                    本協議之解釋與適用，悉依中華民國法律予以處理，會員並同意因本協議所生之爭議，除法律另有規定者外，應以台灣台北地方法院為第一審管轄法院。
                  </li>
                </ol>
              </ListGroup.Item>
              <ListGroup.Item className="text-end" action>
                <span>本文最後更新時間：2021-10-28</span>
              </ListGroup.Item>
            </ListGroup>
          </Row>
        </Container>
      </main>
    </>
  )
}

export default Terms
